import {useState, useMemo} from "react"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import axios from "axios"
import {API_ECP_PROJECTS} from "../../constants/apiUrls"
import {useTranslation} from "react-i18next"
import {useForm} from "react-hook-form"
import Dropzone from "../../components/dropzone/Dropzone"
import {toast} from "react-toastify"
import useTeam from "../../swrCustomHooks/useTeam"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import Select from "react-select"
import {labelMap} from "../../constants/multilingual"
import useCountEcpProjects from "../../swrCustomHooks/useCountEcpProjects"

export default function EcpProjectsModalForm({mutateEcpProjects, closeModal}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {ecpProjectsContext} = useEcpProjectsContext()
    const {team, mutateTeam, isLoadingTeam, isErrorTeam} = useTeam(sessionContext.idTeam)
    const {mutateCountEcpProjects} = useCountEcpProjects(ecpProjectsContext.tab)
    const languages = team?.team?.languages || []
    const {register, handleSubmit, formState: {errors}} = useForm({defaultValues: {isPrivate: true}})

    const allLanguages = useMemo(() => {
        return languages
            .map((lang) => ({
                value: lang.code,
                label: t(labelMap[lang.code]),
            }))
            .sort((a, b) => a.label.localeCompare(b.label))
    }, [languages, labelMap])

    const [sourceLanguage, setSourceLanguage] = useState()
    const [isSourceLanguage, setIsSourceLanguage] = useState(true)
    const [uploadFile, setUploadFile] = useState()

    const createProject = async (data) => {
        if (sourceLanguage !== undefined) {
            setIsSourceLanguage(true)
            const bodyRequest = {
                is_public: !data.isPrivate,
                title: data.title,
                lang_code: sourceLanguage.value,
            }
            const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
            if (uploadFile) {
                await axios.post(API_ECP_PROJECTS, bodyRequest, headersRequest)
                .then((response) => {
                    mutateTeam()
                    mutateEcpProjects()
                    mutateCountEcpProjects()
                    axios.post(`${API_ECP_PROJECTS}/${response.data.id}/tries`, {step: "upload", filename: uploadFile.name},  headersRequest)
                    .then((response) => {
                        closeModal()
                        const uploadPromise = axios.put(response.data.uploadUrl, uploadFile)
                        toast.promise(uploadPromise, {
                            pending: t("Upload..."),
                            success: t("Upload completed!"),
                            error: t("An error has occurred"),
                        })
                        uploadPromise
                        .catch((error) => {
                            console.error("PUT /uploadUrl/file: ", error)
                        })
                    })
                    .catch((error) => {
                        console.error(`POST ${API_ECP_PROJECTS}/${response.data.id}/tries`, error)
                        toast.error(t("An error has occurred"))
                    })
                })
                .catch((error) => {
                    switch (JSON.parse(error.request.response).message) {
                        case "Your Team has no enough credits to perform this action":
                            console.error("POST  /projects: ", error)
                            toast.error(t("Not enough credit. Please liaise with the Neurowide sales department."))
                            break
                        default:
                            toast.error(t("An error has occurred"))
                    }
                })
            }
        } else {
            setIsSourceLanguage(sourceLanguage === undefined ? false : true)
        }
    }

    if (isErrorTeam || isLoadingTeam || team.message) return <LoadingComponent/>
    return (
        <>
        <form className="ecp-projects-modal-form">
            <div className="left-content">
                <h3>{t("Project information")}</h3>
                <span className="switch-label">{t("Private")}</span>
                <label className="switch" title={t("Manage project visibility")}>
                    <input type="checkbox" id="is-private" name="is-private" {...register("isPrivate", {type: Boolean})}/>
                    <span className="slider round"></span>
                </label>
                <div className="field">
                    <label>{`${t("Project name")}*`}</label>
                    <input className={`${errors.title ? "not-valid" : ""}`} type="text" id="title" name="title" placeholder="Ex. Projet 01" {...register("title", {required: true, minLength: 2, maxLength: 75})}/>
                </div>
                <label>{`${t("Source language")}*`}</label>
                <Select
                    name="source-language"
                    options={allLanguages}
                    isClearable={false}
                    isSearchable={false}
                    menuShouldScrollIntoView={false}
                    maxMenuHeight={110}
                    className={`basic-single ${!isSourceLanguage && "select-not-valid"}`}
                    classNamePrefix="select"
                    onChange={(value) => setSourceLanguage(value)}
                />
                <span className="mandatory">{`*${t("Required fields")}`}</span>
            </div>
            <div className="right-content">
                <Dropzone type={"ecp"}
                    setUploadFile={setUploadFile}
                    maxSize={500000000}
                    maxDuration={team.team.max_duration * 60}
                    maxCharacters={Math.ceil(team.team.max_duration * 1000)}
                    pdf={true}
                />
            </div>
            <div className="buttons">
                <button className="cancel-btn" onClick={() => closeModal()} title={t("Cancel")}>{t("Cancel")}</button>
                <button className="create-project-btn" onClick={handleSubmit(createProject)} title={t("Create")}>{t("Create")}</button>
            </div>
        </form>
        </>
    )
}